import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WhereToInstallChargerComponent } from './where-to-install-charger.component';
import { SharedStepsUiModule } from '@theia-cc/shared/step-ui';

@NgModule({
  declarations: [WhereToInstallChargerComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([{ path: '', component: WhereToInstallChargerComponent }]),
    SharedStepsUiModule,
  ],
})
export class WhereToInstallChargerModule {}
